// extracted by mini-css-extract-plugin
export var container = "PartnerEnrollmentRequired-module__container___2zQGv";
export var description = "PartnerEnrollmentRequired-module__description___zHfBD";
export var title = "PartnerEnrollmentRequired-module__title___w1Pnc";